import React, { FC } from 'react';

import CrossSellingContents from './CrossSellingContents';
import CrossSellingResource from './CrossSellingResource/CrossSellingResource';

export interface CrossSellingProps { }

const CrossSelling: FC<CrossSellingProps> = () => (
  <>
    <CrossSellingResource autoRequest requestOnLanguageChange />
    <CrossSellingContents />
  </>
);

export default CrossSelling;
